
export default function Footer() {
  const quickLinks = [
    { name: '彩蛋活动', href: '#activities' },
    { name: '福利中心', href: '#benefits' },
    { name: '许愿墙', href: '#wishes' },
    { name: '用户协议', href: '#terms' },
    { name: '隐私政策', href: '#privacy' }
  ];

  const socialLinks = [
    { icon: 'ri-wechat-line', href: 'https://we3.vip/', name: '微信' },
    { icon: 'ri-weibo-line', href: 'https://we3.vip/', name: '微博' },
    { icon: 'ri-qq-line', href: 'https://we3.vip/', name: 'QQ' },
    { icon: 'ri-music-line', href: 'https://we3.vip/', name: '抖音' }
  ];

  return (
    <footer className="bg-gradient-to-r from-purple-900 to-pink-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                <i className="ri-gift-line text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                许愿蛋
              </h3>
            </div>
            <div className="text-purple-100 mb-4 leading-relaxed">
              <p className="text-lg mb-2">彩蛋，福利蛋，惊喜不间断。</p>
              <p>许愿蛋致力于为每一位用户带来充满期待的欢乐时刻，让每一次许愿都变成美好的现实！</p>
            </div>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors duration-200 cursor-pointer"
                  title={social.name}
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">快速链接</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-purple-100 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">联系我们</h4>
            <div className="space-y-3 text-purple-100">
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line"></i>
                <span>info@mizean.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-customer-service-line"></i>
                <span>在线客服</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-time-line"></i>
                <span>7×24小时服务</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="text-center text-sm text-gray-600 space-y-2">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a 
              href="https://beian.miit.gov.cn/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-teal-600 transition-colors"
            >
              浙ICP备16008979号-4
            </a>
            <a 
              href="https://beian.mps.gov.cn/#/query/webSearch" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-teal-600 transition-colors"
            >
              浙公网安备 浙公网安备33011002011347号
            </a>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <p>Copyright © 许愿蛋 版权所有</p>
            <a 
              href="https://we3.vip/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-teal-600 transition-colors"
            >
              Powered by MiZEAN
            </a>
          </div>
          <p>联系邮箱：info@mizean.com</p>
        </div>

      </div>
    </footer>
  );
}
